import { render, staticRenderFns } from "./page-echart.vue?vue&type=template&id=da5f571c"
import script from "./page-echart.vue?vue&type=script&setup=true&lang=js"
export * from "./page-echart.vue?vue&type=script&setup=true&lang=js"
import style0 from "./page-echart.vue?vue&type=style&index=0&id=da5f571c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports